import { Crown } from "lucide-react";

export default function Logo({ className = "", withText = true, tone = "dark" }) {
  const textColor = tone === "light" ? "text-white" : "text-white";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-[#556B2F]">
        <Crown className="h-5 w-5 text-[#D4AF37]" strokeWidth={2.2} />
      </span>
      {withText && (
        <span className={`font-serif text-2xl leading-none ${textColor} tracking-tight`}>
          Crown <span className="text-[#D4AF37]">Coupon</span>
        </span>
      )}
    </div>
  );
}
